import { Middleware } from "@reduxjs/toolkit";

import { initApiToken, initPosSession } from "../actions/sessionActions";
import { store } from "../store";

interface ErrorPayload {
  status: number;
}

interface RejectedAction {
  type: string;
  error: boolean;
  payload: ErrorPayload;
  meta: {
    requestId: string;
  };
}

const isRejectedAction = (action: any): action is RejectedAction => {
  return (
    typeof action === "object" &&
    action !== null &&
    "type" in action &&
    "meta" in action &&
    typeof action.meta === "object" &&
    "requestId" in action.meta
  );
};

const handleInvalidSession = async () => {
  try {
    await store.dispatch(initApiToken());
    await store.dispatch(initPosSession({ silent: true }));
  } catch (error) {
    console.error("handleInvalidSession error: ", error);
  }
};

const sessionMiddleware: Middleware = () => (next) => async (action) => {
  if (isRejectedAction(action)) {
    let result: any = await next(action);

    if (
      result &&
      typeof result === "object" &&
      "error" in result &&
      result.error &&
      "payload" in result &&
      result.payload &&
      typeof result.payload === "object" &&
      "status" in result.payload &&
      (result.payload as ErrorPayload).status === 401
    ) {
      await handleInvalidSession();
      result = await next(action);
    }

    return result;
  }

  return next(action);
};

export default sessionMiddleware;
